import { BlockTypes } from '../../models/block.js';

function mapCourseModelToApiRequest(user, course, options) {
  return {
    userID: user.id,
    title: course.title,
    subjects: course.subjects,
    levels: course.levels,
    content: "",
    courseElements: options.includeBlocks && course.blocks ? mapBlocks(course.blocks) : undefined
  };
}
function mapBlocks(blocks) {
  return blocks?.map(block => {
    let content = null;
    switch (block.type) {
      case BlockTypes.EMBED:
        content = mapEmbedBlock(block);
        break;
      case BlockTypes.LINK:
        content = mapLinkBlock(block);
        break;
      case BlockTypes.REFERENCE:
        content = mapReferenceBlock(block);
        break;
      case BlockTypes.RICHTEXT:
        content = mapRichtextBlock(block);
        break;
      case BlockTypes.YOUTUBE:
        content = mapYoutubeBlock(block);
        break;
      default:
        throw new Error(
        // @ts-expect-error We cannot be certain that we've covered all block
        // types
        `mapBlocks(${block.type}): Unable to determine type of block.`);
    }
    return {
      id: block.id,
      title: block.title,
      type: block.type,
      note: {
        isVisible: block.note.enabled,
        content: block.note.content
      },
      content
    };
  });
}
function mapEmbedBlock(block) {
  return JSON.stringify({
    embedCode: block.embedCode
  });
}
function mapLinkBlock(block) {
  return JSON.stringify({
    description: block.description,
    href: block.href
  });
}
function mapReferenceBlock(block) {
  return JSON.stringify({
    element: block.element,
    product: block.product
  });
}
function mapRichtextBlock(block) {
  return JSON.stringify({
    content: block.content
  });
}
function mapYoutubeBlock(block) {
  return JSON.stringify({
    videoUrl: block.videoUrl
  });
}

export { mapCourseModelToApiRequest };
//# sourceMappingURL=course-to-api.js.map
